<template>
  <div class="animated fadeIn" id="list-decomptes">
    <transition name="fade">
      <b-card no-body>
        <div slot="header">
          <i class="fa fa-justify mr-2"></i>
          <strong>Gestion des délégations territoriales</strong>
        </div>
        <b-card-body class="small-padding">
          <b-row class="">
            <b-col md="6">
              <h6>Liste des délégation territoriales</h6>
              <b-list-group>
                <b-list-group-item v-for="dt in allDts" :key="dt.id" :class="{'bg-warning': dtId === dt.id}" :active="dtId === dt.id">{{ dt.libelle }} <i v-if="canManageDelegation()" class="icon fa fa-trash float-right clickable ml-2 text-danger" @click="deleteDelegation(dt.id)"></i><i v-if="canManageDelegation()" class="icon fa fa-pencil float-right clickable" @click="edit(dt)"></i></b-list-group-item>
              </b-list-group>
            </b-col>
            <b-col md="6">
              <b-card :header-bg-variant="action === 'create' ? 'primary' : 'warning' ">
                <template v-slot:header >
                   <i class="fa fa-justify mr-2"></i>
                  <strong>{{ libelleFormCardTitle }}</strong>
                </template>
                <b-row>
                  <b-col md="12">
                    <b-form-group
                      label='Libellé'
                      label-for='libelle'
                    >
                      <b-form-input id='libelle' type='text' v-model="libelle" :class="{hasError: errors.libelle !== ''}"></b-form-input>
                      <span class='field-error'>{{ errors.libelle }}</span>
                    </b-form-group>
                    <b-form-group
                      label='Nom du contact'
                      label-for='nomContact'
                    >
                      <b-form-input id='nomContact' type='text' v-model="nomContact" :class="{hasError: errors.nomContact !== ''}"></b-form-input>
                      <span class='field-error'>{{ errors.nomContact }}</span>
                    </b-form-group>
                    <b-form-group
                      label='Email du contact'
                      label-for='emailContact'
                    >
                      <b-form-input id='emailContact' type='text' v-model="emailContact" :class="{hasError: errors.emailContact !== ''}"></b-form-input>
                      <span class='field-error'>{{ errors.emailContact }}</span>
                    </b-form-group>
                    <b-form-group
                      label='Téléphone du contact'
                      label-for='telContact'
                    >
                      <b-form-input id='telContact' type='text' v-model="telContact" :class="{hasError: errors.telContact !== ''}"></b-form-input>
                      <span class='field-error'>{{ errors.telContact }}</span>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col md="12">
                    <b-form-group label="Liste des délégations commerciales">
                      <b-form-checkbox
                        v-for="dr in allDrs"
                        v-model="drIds"
                        :key="dr.id"
                        :value="dr.id"
                        name="drIds"
                      >
                        <span>{{ dr.nom }}</span> <span v-if="dr.delegation_territoriale !== null" class="ml-4 smaller text-warning"><i>({{ dr.delegation_territoriale.libelle }})</i></span>
                      </b-form-checkbox>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col md="12">
                    <b-button v-if="action === 'create'" size="md" variant="primary" @click="create()" class="mr-2 mt-1 pull-right"><i class="fa fa-save"></i> Créer</b-button>
                    <b-button v-if="action === 'modify'" size="md" variant="warning" @click="modify()" class="mr-2 mt-1 pull-right"><i class="fa fa-save"></i> Modifier</b-button>
                    <b-button type="button" @click.prevent="clearForm()" size="md" variant="secondary" class="mr-2 mt-1 pull-right">
                      <i class="fa fa-eraser"></i> Annuler
                    </b-button>
                  </b-col>
                </b-row>
              </b-card>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
    </transition>
  </div>
</template>

<script>
import { getBaseUrl, getProvider, getIdToken, getAccessToken } from '@/utils/auth'
import { hasRule, rules } from "@/utils/rulesHelper"

export default {
  data() {
    return {
      dtId: '',
      allDts: [],
      allDrs: [],
      drIds: [],
      libelle: '',
      nomContact: '',
      emailContact: '',
      telContact: '',
      action: 'create',
      libelleFormCardTitle: 'Création d\'une délégation territoriale',
      errors: {
        libelle: '',
        nomContact: '',
        emailContact: '',
        telContact: '',
      }
    }
  },
  mounted() {
    this.getDelegations()
    this.getDrs()
  },
  created() {
    this.$axios.defaults.baseURL = getBaseUrl();
    this.$axios.defaults.headers.common['Authorization'] = getIdToken() + ' ' + getAccessToken()
    this.$axios.defaults.headers.common['Accept'] = 'application/json';
    this.$axios.defaults.headers.common['Provider'] = getProvider();
  },
  methods: {
    getDelegations() {
      let self = this

      this.$store.commit("IS_LOADING", true)
      this.$axios
        .get("/delegationTerritoriale/all")
        .then(response => {
          this.$store.commit("IS_LOADING", false)

          this.allDts = response.data.data
        })
        .catch(function(error) {
          // console.log(error)
          self.$store.commit("IS_LOADING", false)
          self.$swal({
            position: "top",
            type: "error",
            title: "Attention !!",
            text: "Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI",
            showConfirmButton: false,
            timer: 5000
          })
        })
    },
    getDrs() {
      let self = this

      this.$store.commit("IS_LOADING", true)
      this.$axios
        .get("/delegation/all")
        .then(response => {
          this.$store.commit("IS_LOADING", false)

          this.allDrs = response.data.data
          console.log(this.allDrs)
        })
        .catch(function(error) {
          // console.log(error)
          self.$store.commit("IS_LOADING", false)
          self.$swal({
            position: "top",
            type: "error",
            title: "Attention !!",
            text: "Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI",
            showConfirmButton: false,
            timer: 5000
          })
        })
    },
    create() {
      if (this.validate()) {
        let self = this;
        let dataPost = {
          // 'provider': getProvider(),
          'libelle': this.libelle,
          'nom_contact': this.nomContact,
          'email_contact': this.emailContact,
          'tel_contact': this.telContact,
          'drIds': this.drIds,
        }
        this.$store.commit('IS_LOADING', true)
        this.$axios
          .post('/delegationTerritoriale/add', dataPost)
          .then(response => {
            this.$store.commit('IS_LOADING', false)
            this.clearForm()
            this.clearError()
            this.getDelegations()
            this.getDrs()
          })
          .catch(function(error) {
            self.$store.commit('IS_LOADING', false)
            self.$swal({
              position: 'top',
              type: 'error',
              title: 'Attention !!',
              text: 'Une erreur est survenue lors de la création de la délégation, si le problème persiste merci de faire un ticket au support DOSI',
              showConfirmButton: false,
              timer: 5000
            });
          });
      }
    },
    modify() {
      if (this.validate()) {
        let self = this;
        let dataPost = {
          // 'provider': getProvider(),
          'libelle': this.libelle,
          'nom_contact': this.nomContact,
          'email_contact': this.emailContact,
          'tel_contact': this.telContact,
          'drIds': this.drIds,
        }
        this.$store.commit('IS_LOADING', true)
        this.$axios
          .post('/delegationTerritoriale/modify/'+this.dtId, dataPost)
          .then(response => {
            this.$store.commit('IS_LOADING', false)
            this.clearForm()
            this.clearError()
            this.getDelegations()
            this.getDrs()
          })
          .catch(function(error) {
            self.$store.commit('IS_LOADING', false)
            self.$swal({
              position: 'top',
              type: 'error',
              title: 'Attention !!',
              text: 'Une erreur est survenue lors de la modification de la délégation, si le problème persiste merci de faire un ticket au support DOSI',
              showConfirmButton: false,
              timer: 5000
            });
          });
      }
    },
    deleteDelegation(dtId) {
      let self = this;
      this.$swal
        .fire({
          title: "Êtes-vous sûr?",
          text: "Voulez-vous vraiment supprimer cette délégation territoriale ?",
          type: "warning",
          reverseButtons: true,
          showCancelButton: true,
          allowOutsideClick: false,
          cancelButtonColor: "#ff1744",
          confirmButtonText: "Annuler",
          cancelButtonText: "Supprimer"
        })
        .then(result => {
          if (!result.value) {
            this.$store.commit("IS_LOADING", true)
            this.$axios
              .get("/delegationTerritoriale/delete/"+dtId).then(response => {
                this.$store.commit("IS_LOADING", false)
                this.getDelegations()
                this.getDrs()
              })
              .catch(function(error) {
                  self.$store.commit("IS_LOADING", false)
                  console.log(error.response.status)
                  let errorText = "Une erreur est survenue, lors de la suppression de la délégation. Si le problème persiste, merci de faire un ticket au support DOSI."
                  if (error.response.status === 403) { errorText = "Vous n'êtes pas autorisé à effectuer cette action" }
                  self.$swal({
                  position: "top",
                  type:"error",
                  title:"Attention !!",
                  text:errorText,
                  showConfirmButton: false,
                  timer: 5000
                })
              })
          }
        })
    },
    canManageDelegation() {
      return hasRule(rules.MANAGE_TABLE_DELEGATION)
    },
    edit(dt) {
      this.libelle = dt.libelle
      this.nomContact = dt.nom_contact
      this.emailContact = dt.email_contact
      this.telContact = dt.tel_contact
      this.dtId = dt.id
      this.drIds = dt.delegation_commerciales.map( item => item.id)
      this.action = 'modify'
      this.libelleFormCardTitle = 'Modification de la délégation territoriale : ' + dt.libelle
    },
    validate() {
      let valid = true

      if (this.libelle === '') {
        this.errors.libelle = 'Le libelle est obligatoire'
        valid = false;
      }

      if (this.nomContact === '') {
        this.errors.nomContact = 'Le nom du contact est obligatoire'
        valid = false;
      }

      if (this.emailContact === '') {
        this.errors.emailContact = 'L\'email du contact est obligatoire'
        valid = false;
      }

      if (this.telContact === '') {
        this.errors.telContact = 'Le téléphone du contact est obligatoire'
        valid = false;
      }

      return valid
    },
    clearForm() {
      this.clearError()
      this.dtId = ''
      this.libelle = ''
      this.nomContact = ''
      this.emailContact = ''
      this.telContact = ''
      this.drIds = []
      this.action = 'create'
      this.libelleFormCardTitle = 'Création d\'une délégation territoriale'
    },
    clearError() {
      this.errors.libelle = ''
      this.errors.nomContact = ''
      this.errors.emailContact = ''
      this.errors.telContact = ''
    },
  }
}
</script>